import { useState } from "react";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import AuthLayout from "./AuthLayout";
import Field from "./components/Field";
import Select from "./components/Select";
import Button from "./components/Button";
import Stack from "./components/Stack";
import { CATEGORIES } from "./categories";
import { registerService } from "./api";

export default function RegisterServices() {
  const history = useHistory();
  const [category, setCategory] = useState(CATEGORIES[0].value);
  const [experience, setExperience] = useState("");
  const [pincode, setPincode] = useState("");
  const [description, setDescription] = useState("");

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!pincode || !experience || !description) {
      toast.error("Please fill in every field.");
      return;
    }
    try {
      const res = await registerService({
        uname: localStorage.getItem("username"),
        user_id: localStorage.getItem("user_id"),
        service_category: category,
        pincode,
        experience,
        description,
      });
      if (res.data.message === "listed") {
        localStorage.setItem("usertype", "SP");
        localStorage.setItem("isvisible", "visible");
        toast.success("Service listed!");
        history.push("/profile");
      } else {
        toast.error("Listing unsuccessful. Try again.");
      }
    } catch (error) {
      console.log(error);
      toast.error("Listing unsuccessful. Try again.");
    }
  };

  return (
    <AuthLayout title="List your service" subtitle="Tell customers what you do and where.">
      <form onSubmit={onSubmit}>
        <Stack gap="5">
          <Select
            id="category"
            label="Service"
            value={category}
            onChange={(e) => setCategory(e.target.value)}
            options={CATEGORIES}
            required
          />
          <Field id="experience" label="Years of experience" type="number" value={experience}
                 onChange={(e) => setExperience(e.target.value)} placeholder="e.g. 3" required />
          <Field id="pincode" label="Pincode" value={pincode}
                 onChange={(e) => setPincode(e.target.value)} placeholder="e.g. 400001" required />
          <Field id="description" label="Description" textarea value={description}
                 onChange={(e) => setDescription(e.target.value)}
                 placeholder="Describe your service" required />
          <Button type="submit">List service</Button>
        </Stack>
      </form>
    </AuthLayout>
  );
}
